// store/priceSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import consts from "../../constant";

interface PriceState {
    orderHistory: any | null;
    isLoading: boolean;
    error: string | null;
    depositHistory: any | null;
    withdrawhistory: any | null
    convertHistory: any | null,
    getReferalHistory: any | null
}

const initialState: PriceState = {
    orderHistory: null,
    depositHistory: null,
    isLoading: false,
    error: null,
    withdrawhistory: null,
    convertHistory: null,
    getReferalHistory: null
};

const url = `${consts.BackendUrl}`


// Async thunk for REST API fallback
export const getOrderDetails = createAsyncThunk(
    "history/getOrderDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/history/orderHistory`, {
                // withCredentials: true,
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Get Order History failed!");
            }
            return rejectWithValue("Get Order History failed!");
        }
    }
);


export const getDepositDetails = createAsyncThunk(
    "history/getDepositDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/history/depositHistory`, {
                // withCredentials: true,
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Get Order History failed!");
            }
            return rejectWithValue("Get Order History failed!");
        }
    }
);
export const getWithdrawDetails = createAsyncThunk(
    "history/getWithdrawDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/wallet/getWithdrarData`, {
                // withCredentials: true,
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Get Order History failed!");
            }
            return rejectWithValue("Get Order History failed!");
        }
    }
);

export const createConvert = createAsyncThunk(
    "history/convert",
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/convert/convert`, payload, {
                // withCredentials: true,
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Get Order History failed!");
            }
            return rejectWithValue("Get Order History failed!");
        }
    }
)


export const getConvertHistory = createAsyncThunk(
    "history/getConvertHistory",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/convert/getConvertHistory`, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Get Convert History failed!");
            }
            return rejectWithValue("Get Convert History failed!");
        }
    }
)

export const getUserReferalHistory = createAsyncThunk(
    "history/getUserReferalHistory",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${url}/history/getUserReferalHistory`, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Get Refral History failed!");
            }
            return rejectWithValue("Get Referral History failed!");
        }
    }
)





const historySlice = createSlice({
    name: "history",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrderDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getOrderDetails.fulfilled, (state, action) => {
                state.orderHistory = action?.payload
                state.isLoading = false;
            })
            .addCase(getOrderDetails.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })

            .addCase(getDepositDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getDepositDetails.fulfilled, (state, action) => {
                state.depositHistory = action?.payload
                state.isLoading = false;
            })
            .addCase(getDepositDetails.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(getWithdrawDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getWithdrawDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.withdrawhistory = action?.payload
            })
            .addCase(getWithdrawDetails.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(getConvertHistory.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getConvertHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.convertHistory = action?.payload
            })
            .addCase(getConvertHistory.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(getUserReferalHistory.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getUserReferalHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getReferalHistory = action?.payload
            })
            .addCase(getUserReferalHistory.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            });
    },
});




export default historySlice.reducer;
